<template>
  <button
    :class="['button', `button_${type}`, { 'button_disabled': disabled }]"
    :type="buttonNativeType"
    @click="onClick"
  >
    <slot />
  </button>
</template>

<script>
  export default {
    name: 'BaseButton',
    props: {
      buttonNativeType: String,
      type: {
        type: String,
        default: 'main',
        validator (type) {
          return type === 'main' ||
            type === 'secondary' ||
            type === 'secondary-arrow' ||
            type === 'dark' ||
            type === 'primary'
        }
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onClick () {
        if (this.disabled) return
        this.$emit('click')
      }
    }
  }
</script>

<style lang="scss">
  .button {
    text-align: center;
    cursor: pointer;
    border: none;
    border-radius: 3em;
    outline: none;
    transition: 0.3s;

    &_primary {
      width: 100%;
      padding: 1em 2.5em;
      font-size: 15px;
      line-height: 1;
      color: $c-white;
      background-color: $c-azure;
      border-radius: 0;

      &:focus {
        background-color: $c-azure;
      }

      @include hover {
        background-color: $c-azure;
      }
    }

    &_main {
      padding: 1em 2.5em;
      font-size: 15px;
      line-height: 1;
      color: $c-white;
      background-color: $c-gray-new;

      &:focus {
        background-color: $c-gray-new;
      }

      @include hover {
        background-color: $c-gray-new;
      }
    }

    &_secondary {
      padding: 0.8em 2.75em;
      font-size: 15px;
      color: $c-gray-dark;
      background-color: $c-gray-light;

      &:focus {
        background-color: $c-gray;
      }

      @include hover {
        background-color: $c-gray;
      }
    }

    &_dark {
      width: 100%;
      padding: 0.8em 2.75em;
      font-size: 15px;
      color: $c-white;
      background-color: $c-gray-dark;
    }

    &_secondary-arrow {
      position: relative;
      padding: 0.8em 57px 0.8em 30px;
      font-size: 15px;
      color: $c-gray-dark;
      background-color: $c-gray-light;

      &::before {
        position: absolute;
        top: 50%;
        right: 22px;
        margin-top: 2px;
        font-family: 'Toyota-icon-restyle', sans-serif;
        font-size: 20px;
        color: $c-active;
        content: "\e913";
        transform: translateY(-50%);
      }

      &:focus {
        background-color: $c-gray;
      }

      @include hover {
        background-color: $c-gray;
      }
    }

    &_disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
</style>
